(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ommicare-lp-measurement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ommicare-lp-measurement')) {
    class OmmiLPMeasurement extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.viewSent = false;
        this.atcSent = false;
        this.dataset.status = this.dataset.preview === 'true' ? 'preview-excluded' : 'awaiting-consent';
        this.tryView();
        document.addEventListener('visitorConsentCollected', () => this.tryView(), {signal});
        window.addEventListener('load', () => this.tryView(), {signal,once:true});
        document.addEventListener('ajaxProduct:added', event => {
          const response = event.detail?.product;
          const items = response?.items || (response ? [response] : []);
          if (!items.some(item => String(item.product_id) === this.dataset.productId)) return;
          this.tryView();
          if (!this.atcSent) this.atcSent = this.emit('atc');
        }, {signal});
      }
      disconnectedCallback() {this.controller?.abort();}
      allowed() {
        if (this.dataset.preview === 'true' || window.Shopify?.designMode || window.Shopify?.inspectMode) return false;
        return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
      }
      emit(action) {
        if (!this.allowed()) return false;
        const name = 'ommi_nw2_' + this.dataset.variant + '_' + action;
        const data = {experiment_id:this.dataset.experiment,experiment_variant:this.dataset.variant,product_id:this.dataset.productId};
        if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name,data);
        if (typeof window.gtag === 'function') {
          window.gtag('event',name,{...data,send_to:'G-W112T3TLRP'});
          this.dataset.status = 'sent';
        } else {
          this.dataset.status = 'pixel-event-only';
        }
        this.dataset.lastEvent = name;
        return true;
      }
      tryView() {if (!this.viewSent) this.viewSent = this.emit('view');}
    }
    customElements.define('ommicare-lp-measurement',OmmiLPMeasurement);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ommicare-nw2-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ommicare-nw2-buy')) {
    class OmmiCareNW2Buy extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.button = this.querySelector('[data-nw2-add]');
        this.status = this.querySelector('[data-nw2-status]');
        this.colours = [...this.querySelectorAll('[data-nw2-colour]')];
        this.addEventListener('change', () => this.updateSelection(), {signal});
        if (this.dataset.mode === 'duo') {
          this.querySelector('form').addEventListener('submit', event => this.addItems(event), {signal});
        } else {
          this.button.addEventListener('click', event => this.addItems(event), {signal});
        }
        this.updateSelection();
      }
      disconnectedCallback() { this.abortController?.abort(); }
      updateSelection() {
        let price = 0;
        this.colours.forEach(select => {
          const option = select.selectedOptions[0];
          if (!option) return;
          price += Number(option.dataset.price || 0);
          const picture = select.closest('label').querySelector('img');
          if (picture && option.dataset.image) {
            picture.removeAttribute('srcset');
            picture.src = option.dataset.image;
            picture.alt = option.textContent.trim();
          }
        });
        const currency = this.dataset.currency || 'HKD';
        this.querySelector('[data-nw2-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency,currencyDisplay:'code'}).format(price / 100);
      }
      async addItems(event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.busy) return;
        this.busy = true;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy','true');
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const quantities = new Map();
          this.colours.forEach(select => {
            if (!select.value || select.selectedOptions[0]?.disabled) throw new Error(this.dataset.error);
            quantities.set(select.value, (quantities.get(select.value) || 0) + 1);
          });
          const items = [...quantities].map(([id,quantity]) => ({id:Number(id),quantity}));
          const response = await fetch(root + 'cart/add.js', {
            method:'POST',headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
            body:JSON.stringify({items,sections:['cart-ajax'],sections_url:window.location.pathname})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          added = true;
          if (!result.sections?.['cart-ajax']) {
            const markup = await fetch(root + '?section_id=cart-ajax');
            if (!markup.ok) throw new Error(this.dataset.success);
            result.sections = {'cart-ajax':await markup.text()};
          }
          this.status.textContent = this.dataset.success;
          this.dispatchEvent(new CustomEvent('ajaxProduct:added',{bubbles:true,detail:{product:result,addToCartBtn:this.button,preventCartOpen:this.dataset.mode === 'cart'}}));
          if (document.getElementById('CartPageForm')) document.dispatchEvent(new CustomEvent('cart:build'));
          if (!document.querySelector('header-cart-drawer') && this.dataset.mode === 'duo') window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.setAttribute('data-error','');
          this.status.textContent = added ? this.dataset.success : (error.message || this.dataset.error);
          this.status.focus();
          document.dispatchEvent(new CustomEvent('cart:build'));
        } finally {
          this.busy = false;
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }
    }
    customElements.define('ommicare-nw2-buy',OmmiCareNW2Buy);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ommicare-shipping-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ommicare-shipping-progress')) {
    let currentCart = null;
    let pending = null;
    let timer = null;
    let mopEstimateRate = null;
    let currencyRequest = null;
    const loadMopEstimate = () => {
      if (currencyRequest) return currencyRequest;
      currencyRequest = fetch('https://cdn.shopify.com/s/javascripts/currencies.js', {credentials:'omit',referrerPolicy:'no-referrer'})
        .then(response => response.ok ? response.text() : '')
        .then(source => {
          const hkd = Number(source.match(/(?:[,{])HKD:([.\deE+-]+)/)?.[1]);
          const mop = Number(source.match(/(?:[,{])MOP:([.\deE+-]+)/)?.[1]);
          const rate = hkd / mop;
          if (!Number.isFinite(rate) || rate <= 0) return;
          mopEstimateRate = rate;
          document.querySelectorAll('ommicare-shipping-progress').forEach(element => element.render());
        }).catch(() => {});
      return currencyRequest;
    };
    const applyCart = cart => {
      if (!cart || !Number.isFinite(Number(cart.total_price))) return;
      currentCart = cart;
      document.querySelectorAll('ommicare-shipping-progress').forEach(element => element.setCart(cart));
    };
    const refresh = () => {
      if (pending) return pending;
      const root = window.Shopify?.routes?.root || '/';
      pending = fetch(root + 'cart.js', {credentials:'same-origin',cache:'no-store'})
        .then(response => response.ok ? response.json() : null)
        .then(applyCart).catch(() => {}).finally(() => {pending = null;});
      return pending;
    };
    const scheduleRefresh = () => {clearTimeout(timer); timer = setTimeout(refresh, 100);};
    class OmmiShippingProgress extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.total = Number(this.dataset.cartTotal || 0);
        this.currency = this.dataset.currency;
        this.variants = JSON.parse(this.dataset.variants || '[]');
        this.host = this.closest('block-buy-buttons') || this.closest('ommicare-warmth-product');
        if (this.host?.dataset.selectionTotal) {
          this.selectedTotal = Number(this.host.dataset.selectionTotal);
          this.selectionAvailable = this.host.dataset.selectionAvailable === 'true';
        }
        const scope = this.closest('[data-section-id]')?.parentElement || this.host || this;
        scope.addEventListener('change', () => this.render(), {signal});
        scope.addEventListener('input', () => this.render(), {signal});
        scope.addEventListener('quantity:change', () => this.render(), {signal, capture:true});
        if (this.dataset.productId) {
          document.addEventListener('variant:change:' + this.dataset.sectionId + ':' + this.dataset.productId, () => this.render(), {signal});
        }
        document.addEventListener('ommi:selection', event => {
          if (this.closest('ommicare-warmth-product') === event.target) {
            this.selectedTotal = event.detail.total;
            this.selectionAvailable = event.detail.available;
            this.render();
          }
        }, {signal});
        this.render();
        scheduleRefresh();
      }
      disconnectedCallback() {this.controller?.abort();}
      setCart(cart) {
        this.total = Number(cart.total_price);
        this.currency = cart.currency || this.currency;
        this.dataset.cartTotal = String(this.total);
        this.render();
      }
      render() {
        const isHKD = this.currency === 'HKD';
        const conversion = window.Shopify?.currency;
        const shopifyRate = conversion?.active === 'MOP' ? Number(conversion.rate) : NaN;
        const rate = isHKD ? 1 : this.currency === 'MOP' && this.dataset.baseCurrency === 'HKD' ? (shopifyRate > 0 ? shopifyRate : mopEstimateRate) : NaN;
        const canEstimate = Number.isFinite(rate) && rate > 0;
        const threshold = Math.ceil(Number(this.dataset.threshold) * rate);
        const projection = this.querySelector('[data-shipping-projection]');
        const estimate = this.querySelector('[data-shipping-estimate]');
        this.querySelector('.ommi-shipping__track').hidden = !canEstimate;
        estimate.hidden = isHKD || !canEstimate;
        if (!canEstimate) {
          this.querySelector('[data-shipping-message]').textContent = this.dataset.rule;
          projection.hidden = true;
          if (this.currency === 'MOP' && this.dataset.baseCurrency === 'HKD') loadMopEstimate();
          return;
        }
        const gap = Math.max(0, threshold - this.total);
        const format = value => (isHKD ? 'HK$' : 'MOP ') + (value / 100).toLocaleString('en-HK',{minimumFractionDigits:2,maximumFractionDigits:2});
        if (!estimate.hidden) estimate.textContent = this.dataset.estimatedNote.replace('[amount]',format(threshold));
        const remainingText = isHKD ? this.dataset.remaining : this.dataset.estimatedRemaining;
        const reachedText = isHKD ? this.dataset.reached : this.dataset.estimatedReached;
        this.querySelector('[data-shipping-message]').textContent = gap > 0 ? remainingText.replace('[amount]',format(gap)) : reachedText;
        this.querySelector('[data-shipping-fill]').style.width = Math.min(100,Math.max(0,this.total / threshold * 100)) + '%';
        let selection = this.selectedTotal;
        let available = this.selectionAvailable !== false;
        if (this.host?.matches('block-buy-buttons')) {
          const input = this.host.querySelector('form [name="id"]');
          const variant = this.variants.find(item => String(item.id) === input?.value);
          const formId = this.host.querySelector('form')?.id;
          const scope = this.host.closest('[data-section-id][data-product-id]')?.parentElement;
          const quantityInput = [...(scope?.querySelectorAll('[name="quantity"]') || [])].find(node => node.form?.id === formId || node.getAttribute('form') === formId);
          const quantity = Math.max(1, Number(quantityInput?.value || 1));
          selection = variant ? variant.price * quantity : 0;
          available = Boolean(variant?.available);
        }
        projection.hidden = !available || !selection || gap === 0;
        if (!projection.hidden) {
          const after = Math.max(0, gap - selection);
          const projectedText = isHKD ? this.dataset.projected : this.dataset.estimatedProjected;
          const projectedReachedText = isHKD ? this.dataset.projectedReached : this.dataset.estimatedProjectedReached;
          projection.textContent = after ? projectedText.replace('[amount]',format(after)) : projectedReachedText;
        }
      }
    }
    customElements.define('ommicare-shipping-progress',OmmiShippingProgress);
    document.addEventListener('ajaxProduct:added', scheduleRefresh);
    document.addEventListener('cart:updated', event => event.detail?.cart ? applyCart(event.detail.cart) : scheduleRefresh());
    document.addEventListener('cart:build', scheduleRefresh);
    document.addEventListener('cart:open', scheduleRefresh);
    document.addEventListener('CartDrawer:open', scheduleRefresh);
    window.addEventListener('pageshow', scheduleRefresh);
  }
  } catch(e) { console.error(e); }
})();

})();
